
(function () {
    window.WatchlistApp = window.WatchlistApp || {};

    const Summary = {
        calculateSummary: function (data, holdings, interval) {
            if (!data || !holdings) {
                console.warn('[Summary] missing data or holdings');
                return null;
            }

            let stockInfo = {};

            if (data.stockInfo && data.intervals) {
                stockInfo = data.stockInfo;
            } else if (window.WatchlistDataProcessor && typeof window.WatchlistDataProcessor.processWatchlistReport === 'function') {
                const processed = window.WatchlistDataProcessor.processWatchlistReport(data, interval);
                stockInfo = processed.stockInfo || {};
            } else {
                console.warn('[WatchlistApp] WatchlistDataProcessor not found, cannot calc summary');
                return null;
            }

            let totalDayChange = 0;
            let totalPortfolioChange = 0;
            let currentPortfolioValue = 0;
            let totalQuantity = 0;

            const stockEntries = Object.values(stockInfo);

            stockEntries.forEach(stock => {
                const ticker = stock.ticker;
                const holding = holdings[ticker];

                if (holding && holding.quantity && holding.price) {
                    const quantity = parseFloat(holding.quantity) || 0;
                    const totalCostBasis = parseFloat(holding.price) || 0;

                    if (quantity > 0 && totalCostBasis > 0) {
                        totalQuantity += quantity;
                        const price = parseFloat(stock.price) || 0;
                        const dayChangePerShare = parseFloat(stock.todaysChange) || 0;

                        const rowDayChange = dayChangePerShare * quantity;
                        totalDayChange += rowDayChange;
                        
                        const currentTotalValue = price * quantity;
                        currentPortfolioValue += currentTotalValue;

                        const gainLoss = currentTotalValue - totalCostBasis;
                        totalPortfolioChange += gainLoss;
                    }
                }
            });

            const dayStartValue = currentPortfolioValue - totalDayChange;
            const totalDayChangePerc = dayStartValue !== 0 ? (totalDayChange / dayStartValue) * 100 : 0;

            const intervalStartValue = currentPortfolioValue - totalPortfolioChange;
            const totalPortfolioChangePerc = intervalStartValue !== 0 ? (totalPortfolioChange / intervalStartValue) * 100 : 0;

            const result = {
                totalDayChange,
                totalDayChangePerc,
                totalPortfolioChange,
                totalPortfolioChangePerc,
                currentPortfolioValue,
                totalQuantity
            };
            return result;
        }
    };

    window.WatchlistApp.Summary = Summary;
})();
